import { createSlice } from "@reduxjs/toolkit";
import { duotoneDark } from "react-syntax-highlighter/dist/esm/styles/prism";






const initialManufacturersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  manufacturerForEdit: undefined,

  things: null,
  thingForEdit: undefined,

  thingConfigs: null,
  thingConfigForEdit: undefined,
  thingConfigsTotalCount: 0,
  listLoadingThingConfig: false,
  actionsLoadingThingConfig: false,

  

  
  deviceTypes: null,
  thingsTotalCount: 0,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const manufacturersSlice = createSlice({
  name: "manufacturers",
  initialState: initialManufacturersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    catchErrorThingConfig: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingConfig = false;
      } else {
        state.actionsLoadingThingConfig = false;
      }
    },
    startCallThingConfig: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingConfig = true;
      } else {
        state.actionsLoadingThingConfig = true;
      }
    },

    // getManufacturerById
    manufacturerFetched: (state, action) => {
      state.actionsLoading = false;
      state.manufacturerForEdit = action.payload.manufacturerForEdit;
      state.error = null;
    },
    // findManufacturers
    manufacturersFetched: (state, action) => {
      const { totalCount, data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = totalCount;
    },
    // createManufacturer
    manufacturerCreated: (state, action) => {
     
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
    },
    // updateManufacturer
    manufacturerUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.manufacturer.id) {
          return action.payload.manufacturer;
        }
        return entity;
      });
    },
    // deleteManufacturer
    manufacturerDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },

    // getThingById
    thingFetched: (state, action) => {
      state.actionsLoading = false;
      state.thingForEdit = action.payload.thingForEdit;
      state.error = null;
    },
    // findThings
    thingsFetched: (state, action) => {
      const { totalCount, data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.things = data;
      state.thingsTotalCount = totalCount;
    },
    // createThing
    thingCreated: (state, action) => {
      
      state.actionsLoading = false;
      state.error = null;
      state.things.push(action.payload.data);
    },
    // updateThing
    thingUpdated: (state, action) => {
     
      state.error = null;
      state.actionsLoading = false;
      state.things = state.things.map((entity) => {
        if (entity.id === action.payload.thing.id) {
          return action.payload.thing;
        }
        return entity;
      });
    },
    // deleteThing
    thingDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.things = state.things.filter((el) => el.id !== action.payload.id);
    },

    // getThingConfigById
    thingConfigFetched: (state, action) => {
      state.actionsLoadingThingConfig = false;
      state.thingConfigForEdit = action.payload.thingConfigForEdit;
      state.error = null;
    },
    // find thingConfigs
    thingConfigsFetched: (state, action) => {
      const { totalCount, data } = action.payload;
      state.listLoadingThingConfig = false;
      state.error = null;
      state.thingConfigs = data;
    },
    // create thingConfig
    thingConfigCreated: (state, action) => {      
      state.actionsLoadingThingConfig = false;
      state.error = null;
      state.thingConfigs.push(action.payload.data);
      state.thingConfigForEdit = undefined;
    },
    // update thingConfig
    thingConfigUpdated: (state, action) => {
      state.error = null;
      state.actionsLoadingThingConfig = false;
      state.thingConfigForEdit = undefined;
      state.thingConfigs = state.thingConfigs.map((entity) => {
        if (entity.id === action.payload.thingConfig.id) {
          return action.payload.thingConfig;
        }
        return entity;
      });
    },
    // delete thingConfig
    thingConfigDeleted: (state, action) => {
      state.error = null;
      state.actionsLoadingThingConfig = false;
      state.thingConfigs = state.thingConfig.filter(
        (el) => el.id !== action.payload.id
      );
    },
    // get Room Types
    deviceTypesFetched: (state, action) => {
      state.actionsLoading = false;
      state.deviceTypes = action.payload.deviceTypes;
      state.error = null;
    },








  },
});
